const map = {
	"./arrow-down.svg": 4598,
	"./arrow-right.svg": 352,
	"./chevron-down.svg": 3816,
	"./close.svg": 369,
	"./download.svg": 1114,
	"./menu.svg": 2003
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;